export function objectToFormData(
  obj: any,
  objectsToStringify: string[] = []
): FormData {
  const formData = new FormData();

  for (const key of Object.keys(obj)) {
    let value = obj[key];
    if (objectsToStringify.includes(key)) {
      value = JSON.stringify(value);
    } else {
      formData.append(key, value);
    }
  }

  return formData;
}

export function isInDevelopmentMode(): boolean {
  return process.env.NODE_ENV === 'development';
}

export function isInProductionMode(): boolean {
  return process.env.NODE_ENV === 'production';
}
